module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OoSBMt/tc-custom/9781440523816.jpg?1730548085207",
      "alt": "This image is the cover for the book Everything Tex-Mex Cookbook, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Tex-Mex Cookbook, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An American tradition since the 1800s, Tex-Mex food combines the flavors of a wide variety of ingredients with the influence of different cultures to create unique dishes that are crafted to perfection.")]), _c('br'), _c('br'), _vm._v("Tomatoes, beef, beans, chiles, and corn are the staples of Tex-Mex cooking, while flavor, texture, and personality are added with specialties such as hot sauce, chorizo, and spices such as chili pepper and cayenne pepper. Packed with 300 not-quite-south-of-the-border recipes, "), _c('i', [_vm._v("The Everything Tex-Mex Cookbook")]), _vm._v(" brings these authentic flavors to your very own kitchen."), _c('br'), _c('br'), _vm._v("Features recipes for:"), _c('br'), _vm._v(" -Chilled Avocado Soup"), _c('br'), _vm._v(" -Red Snapper Flautas"), _c('br'), _vm._v(" -Oven Barbecued Beef Brisket"), _c('br'), _vm._v(" -Chicken Chimichangas"), _c('br'), _vm._v(" -Mixed Bean Lasagna"), _c('br'), _vm._v(" -Red Sangria"), _c('br'), _vm._v(" -Peach Daiquiri Pie"), _c('br'), _c('br'), _vm._v("Whether you’re looking for a quick party appetizer, dinner for your family, or drinks and dessert, "), _c('i', [_vm._v("The Everything Tex-Mex Cookbook")]), _vm._v(" has everything you need to add some color and spice to your daily menus!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Larsen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0